import { useNavigate } from "react-router";
import { EncounterPicker } from "./EncounterPicker";
import { ROUTES } from "./navigation";
import type { RawFilesViewerEncounter } from "./useEncounterById";

export default function RawFilesViewerPage() {
  const navigate = useNavigate();

  const handleSelectEncounter = (encounter: RawFilesViewerEncounter) => {
    navigate(`${ROUTES.rawFilesViewer.route}/${encounter.id}`);
  };

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-baseline gap-2 border-b pb-3">
        <h1 className="text-base font-semibold">Raw Files Viewer</h1>
        <span className="text-sm text-muted-foreground">
          Pick an encounter to view every raw file bundle ingested for that patient.
        </span>
      </div>

      <EncounterPicker onSelectEncounter={handleSelectEncounter} />
    </div>
  );
}
